var ChainID;

(function (ChainID) {
  ChainID[ChainID["Testnet"] = 2147483648] = "Testnet";
  ChainID[ChainID["Mainnet"] = 1] = "Mainnet";
})(ChainID || (ChainID = {}));

var TransactionVersion;

(function (TransactionVersion) {
  TransactionVersion[TransactionVersion["Mainnet"] = 0] = "Mainnet";
  TransactionVersion[TransactionVersion["Testnet"] = 128] = "Testnet";
})(TransactionVersion || (TransactionVersion = {}));
var BLOCKSTACK_DEFAULT_GAIA_HUB_URL = 'https://hub.blockstack.org';

export { BLOCKSTACK_DEFAULT_GAIA_HUB_URL, ChainID, TransactionVersion };
//# sourceMappingURL=constants.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/auth/node_modules/@stacks/profile/node_modules/@stacks/network/node_modules/@stacks/common/dist/constants.esm.js
// module id = null
// module chunks = 